module.exports = __webpack_public_path__ + "static/Inserat2024Payrollspezialist-cffa1b17e67d9c5f3f0cabd53c90ff07.pdf";